export default {"src":"/_next/static/media/cleeaiLogoV2.9a1aebd6.svg","height":49,"width":176,"blurWidth":0,"blurHeight":0};